"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.howManyDaysOfAvailabilityToShow = exports.getUserAndTokenFromStorage = exports.getUser = exports.hasPermission = void 0;
// @ts-ignore
var jwt_decode_1 = __importDefault(require("jwt-decode"));
var lodash_1 = require("lodash");
var functions_1 = require("./functions");
var getUser = function () {
    if (typeof window !== 'undefined') {
        var user = localStorage.getItem('user') || '';
        return user.length > 0 ? JSON.parse(user) : {};
    }
    return {};
};
exports.getUser = getUser;
var getUserAndTokenFromStorage = function () {
    if (functions_1.isBrowser) {
        var user = window.localStorage.getItem('user') || '';
        return user.length > 0 ? JSON.parse(user) : { user: null, token: null };
    }
    return { user: null, token: null };
};
exports.getUserAndTokenFromStorage = getUserAndTokenFromStorage;
/**
 * Checks if a permission exist for a user. Can pass a single string or array of Perms
 * @param permission
 * @returns {boolean|*}
 */
var hasPermission = function (permission) {
    var user = getUser();
    if ((0, lodash_1.isEmpty)(user) || !user.token) {
        return false;
    }
    var decodedJWT = (0, jwt_decode_1.default)(user.token);
    var userData = JSON.parse(decodedJWT.sub);
    if (typeof permission === 'string') {
        return userData.permissionsList && userData.permissionsList.includes(permission);
    }
    // check array list of permissions exist for user
    return permission.filter(function (perm) { return userData.permissionsList.includes(perm); }).length > 0;
};
exports.hasPermission = hasPermission;
var howManyDaysOfAvailabilityToShow = function () { return (hasPermission('ADMIN') || hasPermission('ADVANCED_BOOKINGS') ? 8 : 7); };
exports.howManyDaysOfAvailabilityToShow = howManyDaysOfAvailabilityToShow;
